import React from "react";
import Dispatcher from "../../dispatcher";
import BookStore from "../../stores/book-store";
import FractionStore from "../../stores/fraction-store";
import HighlightPopover from "./highlights/highlight-popover";
import MobileHighlightContainer from "./notebook/mobile-highlight-container";
import Isvg from "../../../vendor/react-inlinesvg";
import ModalStore from "../../stores/modal-store";
import ImagePopover from "./flashcard-images/image-popover";

var isMounted;
class BookPlaceholder extends React.Component {
  constructor(props) {
    super(props);
    this.zoomScale = 1;
    this.state = {
      previousVisible: false,
      nextVisible: false,
      ttsOpen: false
    };

    // Method bindings
    this.moveReaderUp = this.moveReaderUp.bind(this);
    this.moveReaderDown = this.moveReaderDown.bind(this);
    this._updateLocation = this._updateLocation.bind(this);
    this._bookChange = this._bookChange.bind(this);
    this._pageReady = this._pageReady.bind(this);
    this._handleBookKeyUp = this._handleBookKeyUp.bind(this);
    this._handleGlobalKeyUp = this._handleGlobalKeyUp.bind(this);
    this._previousPage = this._previousPage.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._horizontalNavigationEvent = this._horizontalNavigationEvent.bind(this);
    this._horizontalEnter = this._horizontalEnter.bind(this);
    this._showBoth = this._showBoth.bind(this);
    this._hideBoth = this._hideBoth.bind(this);
    this._showPrevious = this._showPrevious.bind(this);
    this._hidePrevious = this._hidePrevious.bind(this);
    this._showNext = this._showNext.bind(this);
    this._hideNext = this._hideNext.bind(this);
    this._pageLoad = this._pageLoad.bind(this);
    this._snippetReady = this._snippetReady.bind(this);
    this._navRequested = this._navRequested.bind(this);
    this._mouseWheel = this._mouseWheel.bind(this);
    this._pageScroll = this._pageScroll.bind(this);
    this._touchStart = this._touchStart.bind(this);
    this._touchMove = this._touchMove.bind(this);
    this._touchEnd = this._touchEnd.bind(this);
    this.renderPreviousButton = this.renderPreviousButton.bind(this);
    this.renderNextButton = this.renderNextButton.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 18);
    Dispatcher.bind(Dispatcher.BOOK_PLACEHOLDER_RESIZE, this._updateLocation);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_SCROLL_FULLSPEED, this._pageScroll);
    Dispatcher.bind(Dispatcher.BOOK_CHANGE, this._bookChange);
    Dispatcher.bind(Dispatcher.BOOK_MOUSE_WHEEL, this._mouseWheel);
    Dispatcher.bind(Dispatcher.BOOK_NAVIGATION_REQUESTED, this._navRequested);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_LOAD, this._pageLoad);
    Dispatcher.bind(Dispatcher.BOOK_TOUCH_START, this._touchStart);
    Dispatcher.bind(Dispatcher.BOOK_TOUCH_MOVE, this._touchMove);
    Dispatcher.bind(Dispatcher.BOOK_TOUCH_END, this._touchEnd);
    Dispatcher.bind(
      Dispatcher.BOOK_MOUSE_MOVE,
      this._horizontalNavigationEvent
    );
    Dispatcher.bind(Dispatcher.BOOK_KEY_UP, this._handleBookKeyUp);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.bind(Dispatcher.BOOK_SNIPPET_READY, this._snippetReady);
    Dispatcher.bind(Dispatcher.TTS_OPEN, this.moveReaderUp);
    Dispatcher.bind(Dispatcher.TTS_CLOSE, this.moveReaderDown);
    $(window).on("keyup", this._handleGlobalKeyUp);
    this._updateLocation();
    this._bookChange();
    isMounted = true;
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOK_PLACEHOLDER_RESIZE, this._updateLocation);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_SCROLL_FULLSPEED, this._pageScroll);
    Dispatcher.unbind(Dispatcher.BOOK_CHANGE, this._bookChange);
    Dispatcher.unbind(Dispatcher.BOOK_MOUSE_WHEEL, this._mouseWheel);
    Dispatcher.unbind(Dispatcher.BOOK_NAVIGATION_REQUESTED, this._navRequested);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_LOAD, this._pageLoad);
    Dispatcher.unbind(Dispatcher.BOOK_TOUCH_START, this._touchStart);
    Dispatcher.unbind(Dispatcher.BOOK_TOUCH_MOVE, this._touchMove);
    Dispatcher.unbind(Dispatcher.BOOK_TOUCH_END, this._touchEnd);
    Dispatcher.unbind(
      Dispatcher.BOOK_MOUSE_MOVE,
      this._horizontalNavigationEvent
    );
    Dispatcher.unbind(Dispatcher.BOOK_KEY_UP, this._handleBookKeyUp);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.unbind(Dispatcher.BOOK_SNIPPET_READY, this._snippetReady);
    Dispatcher.unbind(Dispatcher.TTS_OPEN, this.moveReaderUp);
    Dispatcher.bind(Dispatcher.TTS_CLOSE, this.moveReaderDown);
    $(window).unbind("keyup", this._handleGlobalKeyUp);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 18);
    isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (!this.state.vertical) {
      if (this.showFirstNavigation) {
        setTimeout(
          function() {
            if (isMounted) {
              this.navigationVisible = false;
              this._horizontalNavigationEvent();
              this.forceUpdate();
            }
          }.bind(this),
          500
        );
        this.showFirstNavigation = false;
      }
    }
    if (
      this.state.expectedHighlightHeight !==
      $("#create-highlight-menu").height() + 5
    ) {
      this.setState({
        expectedHighlightHeight: $("#create-highlight-menu").height() + 5
      });
    }

    if (!prevProps.bookAccessDenied && this.props.bookAccessDenied) {
      Fraction.Helpers.removeLoader(".temp-book-load");
      Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
    }
  }

  moveReaderUp() {
    this.setState({ ttsOpen: true });
  }

  moveReaderDown() {
    this.setState({ ttsOpen: false });
  }

  _updateLocation() {
    const placeholder = $("#book-wrapper");
    let positionStyles = {};
    let ariaHidden = false;
    if (placeholder.size() > 0) {
      const placeholderOffset = placeholder.offset();
      if (placeholderOffset) {
        positionStyles = {
          top: placeholderOffset.top,
          left: placeholderOffset.left,
          width: placeholder.width(),
          height: placeholder.height()
        };
      }
    } else {
      positionStyles = {
        top: -3000,
        left: -3000,
        width: 1,
        height: 1
      };
      ariaHidden = true;
    }
    this.setState({
      positionStyles: positionStyles,
      ariaHidden: ariaHidden,
      placeholderHeight: $("#jigsaw-placeholder-outer").height()
    });
  }

  _bookChange() {
    const book = BookStore.get(this.props.isbn);
    // We need to always check the page's scrollHeight on zoom to ensure that we are properly
    // testing to see if the page is scrollable or not.
    if (book && book.zoomScale && book.zoomScale !== this.zoomScale) {
      this.zoomScale = book.zoomScale;
      if (
        this.scrollHeight * book.zoomScale <=
        $("#jigsaw-placeholder-outer").height() + 10
      ) {
        this._showBoth();
      } else {
        this._hideBoth();
      }
    }
    if (!this.state.vertical && !this.state.horizontal) {
      if (book.vbkType) {
        this.setState({
          vertical: book.vbkType !== "pbk" && book.vbkType !== "pdf",
          horizontal: book.vbkType === "pbk" || book.vbkType === "pdf"
        });
      }
    } else {
      this.forceUpdate();
    }
  }

  _pageReady(isbn, e, data) {
    Fraction.Helpers.removeLoader(".temp-book-load");
    this.scrollTop = this.scrollTop || 0;
    clearTimeout(this.loaderTimeout);
    this._updateLocation();
    if (this.state.vertical) {
      this._hideBoth();
    } else {
      this.showFirstNavigation = true;
    }
  }

  _handleBookKeyUp(isbn, e, data) {
    this._handleGlobalKeyUp(data);
  }

  // Handle the window keyup event
  _handleGlobalKeyUp(e) {
    const highlightPopover = FractionStore.get()["popover-open"];

    const hasModifierKey = e.ctrlKey || e.altKey || e.shiftKey || e.metaKey;
    if (
      (!e.target || e.target.nodeName !== "INPUT") &&
      !Fraction.Helpers.isModalOpen() &&
      !ModalStore.openModal() &&
      !highlightPopover &&
      !hasModifierKey
    ) {
      switch (e.keyCode) {
        case 37:
          this._previousPage({ noScroll: true });
          break;
        case 39:
          this._nextPage();
          break;
        default:
          break;
      }
    }
  }

  _previousPage(e) {
    const book = BookStore.get(this.props.isbn);
    if (book.viewer && book.previousPage) {
      Dispatcher.emit(Dispatcher.BOOK_PREVIOUS_PAGE, this.props.isbn);
      // do animate, then switch
      Fraction.Helpers.addLoader(".temp-book-load");
      this.loaderTimeout = setTimeout(function() {
        Fraction.Helpers.removeLoader(".temp-book-load");
        Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
      }, 5000);
      $(".temp-book-load").css("top", "-100%");
      $(".temp-book-load").animate({ top: 0 }, 250);
      if (this.vertical) {
        setTimeout(() => {
          $(".temp-book-load").css("top", "100%");
        }, 75);
        book.viewer.Book.goToPreviousPage(response => {
          this._hideBoth();
          setTimeout(() => {
            if (!e || !e.noScroll) {
              book.viewer.Viewport.scrollToBottom(() => {
                this.animatingDown = false;
                this.animatingUp = false;
                this.forceUpdate();
                this._showNext();
                Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
              });
            }
          }, 750);
        });
      } else {
        book.viewer.Book.goToPreviousPage(function() {
          $(".temp-book-load").css("left", "100%");
          Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
        });
      }
    }
  }

  _nextPage(e) {
    const book = BookStore.get(this.props.isbn);
    if (book.viewer && book.nextPage) {
      Dispatcher.emit(Dispatcher.BOOK_NEXT_PAGE, this.props.isbn);
      // do animate then switch
      Fraction.Helpers.addLoader(".temp-book-load");
      this.loaderTimeout = setTimeout(function() {
        Fraction.Helpers.removeLoader(".temp-book-load");
        Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
      }, 5000);
      $(".temp-book-load").css("top", "100%");
      $(".temp-book-load").animate({ top: 0 }, 250);
      if (this.vertical) {
        this._hideBoth();
        book.viewer.Book.goToNextPage(function() {
          Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
        });
      } else {
        book.viewer.Book.goToNextPage(function() {
          $(".temp-book-load").css("left", "100%");
          Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
        });
      }
    }
  }

  _horizontalNavigationEvent() {
    if (this.state.horizontal) {
      if (!this.navigationVisible) {
        this.navigationVisible = true;
        $(".horizontal-button").css({ height: "", width: "" });
        $(".horizontal-button").fadeIn(350);
      }
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.hideTimeout = setTimeout(() => {
        $(".horizontal-button").fadeOut(350, () => {
          this.navigationVisible = false;
          $(".horizontal-button")
            .show()
            .css({ height: "1px", width: "1px" });
        });
      }, 3000);
    }
  }

  _horizontalEnter() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  _showBoth() {
    this._showPrevious();
    this._showNext();
  }

  _hideBoth() {
    this._hidePrevious();
    this._hideNext();
  }

  _showPrevious() {
    const book = BookStore.get(this.props.isbn);
    if (!this.state.previousVisible && book.previousPage) {
      $("#jigsaw-placeholder-inner").addClass("show-previous");
      this.setState({ previousVisible: true });
    }
  }

  _hidePrevious() {
    if (this.state.previousVisible) {
      $("#jigsaw-placeholder-inner").removeClass("show-previous");
      this.setState({ previousVisible: false });
    }
  }

  _showNext() {
    const book = BookStore.get(this.props.isbn);
    if (!this.state.nextVisible && book.nextPage) {
      $("#jigsaw-placeholder-inner").addClass("show-next");
      this.setState({ nextVisible: true });
    }
  }

  _hideNext() {
    if (this.state.nextVisible) {
      $("#jigsaw-placeholder-inner").removeClass("show-next");
      this.setState({ nextVisible: false });
    }
  }

  _pageLoad(isbn, e, data) {
    const book = BookStore.get(this.props.isbn);
    if (this.state.vertical && data && data.scrollHeight) {
      this.scrollHeight = data.scrollHeight;
      if (
        this.scrollHeight * this.zoomScale <=
        this.state.placeholderHeight + 10
      ) {
        this._showBoth();
      } else {
        const scrollPosition = this.scrollTop || data.scrollTop;
        setTimeout(() => {
          if (scrollPosition === 0) {
            book.viewer.Viewport.scrollTo(1);
          }
        }, 250);
      }
    }
  }

  _snippetReady(isbn, e, data) {
    if (data && data.height) {
      this.scrollHeight = data.height;
    }
  }

  _navRequested() {
    if (this.state.vertical) {
      this._hideBoth();
      this.ignorePageScroll = true;
    }
  }

  _mouseWheel(isbn, e, data) {
    // TODO CLEANUP
    if (this.state.vertical) {
      if (
        (this.scrollTop === undefined || this.scrollTop + data.delta <= 0) &&
        data.delta < 0
      ) {
        this._showPrevious();
      }
      if (data.delta > 0) {
        this._hidePrevious();
      }
      if (
        this.scrollTop + data.delta >=
          this.scrollHeight - this.state.placeholderHeight &&
        data.delta > 0
      ) {
        this._showNext();
      }
      if (data.delta < 0) {
        this._hideNext();
      }
    }
  }

  _pageScroll(isbn, e, data) {
    // TODO CLEANUP
    const book = BookStore.get(this.props.isbn);
    if (this.state.vertical) {
      this.scrollTop = data.scrollTop;
      this.scrollHeight = data.scrollHeight;
      book.viewer.Book.getZoomScale(response => {
        // Need to multiply container scroll height by zoom scale if it's less
        // than 1.  Also need to round down because sometimes the scale leaves
        // pixel height at fraction slightly above container scrollTop
        var zoomScale = response.data.zoomScale;
        if (!zoomScale || zoomScale > 1) {
          zoomScale = 1;
        }

        if (
          this.scrollTop >=
          Math.floor(
            this.scrollHeight * zoomScale - this.state.placeholderHeight
          )
        ) {
          this._showNext();
        }
      });
      if (this.scrollTop <= 0) {
        this._showPrevious();
      }
    }

    // apparently we had two page scrolls, this is the other part of it :/
    if (this.state.vertical) {
      if (
        (this.scrollTop === undefined || this.scrollTop <= 0) &&
        data.scrollTop <= 0
      ) {
        this._showPrevious();
      }
      if (data.scrollTop > 0) {
        this._hidePrevious();
      }
      if (data.scrollTop >= this.scrollHeight - this.state.placeholderHeight) {
        this._showNext();
      }
      if (data.scrollTop < this.scrollHeight - this.state.placeholderHeight) {
        this._hideNext();
      }
    }
  }

  _touchStart(isbn, e, data) {
    this.startDragX = data.x;
    this.startDragY = data.y;
    if (this.state.vertical) {
      if (this.scrollTop <= 0 || this.scrollTop === undefined) {
        this.canShowTop = true;
      } else {
        this.canShowTop = false;
      }
      if (this.scrollTop >= this.scrollHeight - this.state.placeholderHeight) {
        this.canShowBottom = true;
      } else {
        this.canShowBottom = false;
      }
    }
  }

  _touchMove(isbn, e, data) {
    var ydiff;
    if (this.state.vertical) {
      if (this.startDragY) {
        ydiff = data.y - this.startDragY;
        if (ydiff > 20 && this.canShowTop) {
          this._showPrevious();
        } else if (ydiff < -20) {
          this._hidePrevious();
        }
        if (ydiff < -20 && this.canShowBottom) {
          this._showNext();
        } else if (ydiff > 20) {
          this._hideNext();
        }
      }
    }
  }

  _touchEnd(isbn, e, data) {
    this._horizontalNavigationEvent();
    this.startDragX = false;
    this.startDragY = false;
    $("#jigsaw-placeholder-inner").animate(
      {
        right: -0
      },
      50
    );
  }

  renderPreviousButton(book) {
    if (book.previousPage) {
      const direction = this.state.vertical ? "vertical" : "horizontal";
      return (
        <div className={`${direction}-button-wrapper previous-wrapper`}>
          <button
            className={`navigation-button no-button ${direction}-button previous-button`}
            onMouseMove={this._horizontalEnter}
            onClick={this._previousPage}
          >
            <Isvg src={"/img/chevron_left_large.svg"} />
            <span className="offScreen">{i18n.t("base.previous")}</span>
          </button>
        </div>
      );
    }
  }

  renderNextButton(book) {
    if (book.nextPage) {
      const direction = this.state.vertical ? "vertical" : "horizontal";
      return (
        <div className={`${direction}-button-wrapper next-wrapper`}>
          <button
            className={`navigation-button no-button ${direction}-button next-button`}
            onMouseMove={this._horizontalEnter}
            onClick={this._nextPage}
          >
            <Isvg src={"/img/chevron_left_large.svg"} />
            <span className="offScreen">{i18n.t("base.next")}</span>
          </button>
        </div>
      );
    }
  }

  render() {
    const book = BookStore.get(this.props.isbn);
    let buttonVisibility = "";
    if (this.state.previousVisible) {
      buttonVisibility += "show-previous ";
    }
    if (this.state.nextVisible) {
      buttonVisibility += "show-next ";
      if (this.state.ttsOpen) {
        buttonVisibility += "jigsaw-tts ";
      }
    }

    return (
      <div
        aria-hidden={FractionStore.get()["modal-open"]}
        id="jigsaw-placeholder-outer"
        style={this.state.positionStyles}
      >
        <div id="jigsaw-placeholder-inner" className={buttonVisibility}>
          {this.renderPreviousButton(book)}

          <div
            aria-hidden={this.state.ariaHidden}
            aria-label={i18n.t("filter.book-content")}
            role="main"
            tabIndex="-1"
            id="jigsaw-placeholder"
          />

          {this.renderNextButton(book)}

          <div
            className="hidden-request-accessible-version"
            role="complementary"
          >
            <p tabIndex="-1">
              {window.toHTML(
                i18n.t("reader.request-accessibility-version", {
                  url:
                    "mailto:accessibility@ingramcontent.com?Subject=Accessibility%20eText%20Request%20Form:%20" +
                    this.props.isbn
                })
              )}
            </p>
          </div>

          <div className="temp-book-load" />
        </div>

        <HighlightPopover
          isbn={this.props.isbn}
          fastHighlighting={this.props.fastHighlighting}
        />

        <ImagePopover isbn={this.props.isbn} />

        <MobileHighlightContainer />

        {this.props.renderMinimizedChrome("assignment-creator-chrome")}
        {this.props.renderMinimizedChrome("assignment-reader-chrome")}
      </div>
    );
  }
}

module.exports = BookPlaceholder;
